export default "__VITE_ASSET__aad302ba__"